import { render } from "./NewFulfilmentPage.vue?vue&type=template&id=2986d0b4"
import script from "./NewFulfilmentPage.vue?vue&type=script&lang=js"
export * from "./NewFulfilmentPage.vue?vue&type=script&lang=js"

import "./NewFulfilmentPage.vue?vue&type=style&index=0&id=2986d0b4&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__